import React from "react";
import PropTypes from "prop-types";
import { FormItem } from "..";
import { InputGroup, Popover, OverlayTrigger } from "react-bootstrap";
import sampleWatertap from "Public/img/sample-watertap.jpg";

const samplePopover = (
  <Popover className="mw-100">
    <img
      width="580"
      className="mw-100"
      src={sampleWatertap}
      alt="お客様番号見本"
    />
  </Popover>
);

// お客様番号 (= 水栓番号)
const validations = ["watertap"];
class WatertapText extends FormItem {
  static propTypes = FormItem.extendPropTypes({
    placeholder: PropTypes.string
  });
  constructor(props) {
    super(props);
    const self = this;
    self.defineValidations(validations);
    self.refList = [React.createRef(), React.createRef()];
    self.lengthList = [7, 4]; // eslint-disable-line no-magic-numbers
    self.onChange = self.onChange.bind(self);
  }
  getValues() {
    const self = this;
    return (self.getVal() || "-").split("-");
  }
  onChange(index, value) {
    const self = this;
    const values = self.getValues();
    values[index] = value
      .replace(/[０-９]/g, s => String.fromCharCode(s.charCodeAt(0) - 65248))
      .replace(/[^\d]/g, "");
    self.setVal(values.join("-"));
    if (self.refList[index + 1] && value.length >= self.lengthList[index]) {
      self.refList[index + 1].current.focus();
    }
  }
  renderReadonly() {
    const self = this;
    return <p className="mb-0">{self.getVal() || ""}</p>;
  }
  renderInput() {
    const self = this;
    const formControlClassName = self.getFormControlClassName();
    const values = self.getValues();
    return (
      <div>
        <div className="form-inline clearfix">
          <InputGroup className="w-auto">
            <input
              ref={self.refList[0]}
              type="tel"
              className={formControlClassName}
              value={values[0] || ""}
              maxLength={self.lengthList[0]}
              size={8}
              placeholder={self.props.placeholder || "お客様番号"}
              onChange={event => self.onChange(0, event.target.value)}
            />
          </InputGroup>
          <span className="mx-1">―</span>
          <InputGroup className="w-auto">
            <input
              ref={self.refList[1]}
              type="tel"
              className={formControlClassName}
              value={values[1] || ""}
              maxLength={self.lengthList[1]}
              size={5}
              onChange={event => self.onChange(1, event.target.value)}
            />
          </InputGroup>
          <OverlayTrigger
            placement="top-end"
            container={document.getElementById("root")}
            trigger="click"
            rootClose={true}
            overlay={samplePopover}
          >
            <button type="button" className="btn btn-link ml-auto mr-3">
              見本の表示
            </button>
          </OverlayTrigger>
        </div>
        {self.renderValError()}
      </div>
    );
  }
}
export default WatertapText;
